class INTENT.widgets.BqPerformance

  @ATTR_NAME: "data-widget-bq-journal-performance"

  constructor: (@el) ->
    @s = @.constructor

    @el.on 'click', =>
      @showPerformancePopup()


  showPerformancePopup: =>
    @el.showLoader()
    el = @el
    s = @s
    hLoader = ->
      el.hideLoader()
      $("[#{s.ATTR_NAME}]").tooltip 'hide'

    $.post "/admin/journal/performance_popup", {id: @el.parents('tr').data('id')}
    .always ->
      hLoader()
    .done (resp) =>
      hLoader()

      if not resp.success
        INTENT.utils.Notify.danger __("bq.performance_popup_error")
        return

      modalSettings =
        title: __ 'bq.performance_log'
        body: resp.value
        size: "large"
        onClose: hLoader
      INTENT.utils.Modal.show modalSettings

    .fail ->
      hLoader()
      INTENT.utils.Notify.danger __("bq.performance_popup_error")

